export default __webpack_public_path__ + "static/media/kitchen3-after1-1024w.95222977.webp";